import { EthAddress } from '@xylabs/sdk-js'
import { XyoWorldGeotokens } from '@xyo-network/sdk-xyoworld-js'
import { useEffect, useState } from 'react'

import { XyoWorldEntity } from './XyoWorldEntity'

const useEntity = (address?: EthAddress | null, geotokens?: XyoWorldGeotokens | null) => {
  const [entity, setEntity] = useState<XyoWorldEntity>()
  useEffect(() => {
    let completed = false
    const load = () => {
      let data
      if (address) {
        setEntity(undefined)
        data = new XyoWorldEntity(address, geotokens)
      }
      if (!completed) {
        setEntity(data)
      }
    }
    load()
    return () => {
      completed = true
    }
  }, [address, geotokens])

  return entity
}

export default useEntity
